import React, { useCallback, useRef, useState, useEffect } from "react";
import { connect } from "react-redux";
import GridLayoutManager from "../../gridLayoutCustomization/GridLayoutManager";
import DataSource from "devextreme/data/data_source";
import {
    Column,
    DataGrid,
    Scrolling,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Editing,
    Export,
    Pager,
    Toolbar,
    Item,
    RequiredRule
} from "devextreme-react/data-grid";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { createConcurrencyAwareStore, refreshGridOnConflict } from "../../common/dataStore";
import "jspdf-autotable";
import { Button, SelectBox } from 'devextreme-react';
import axios from "axios";
import routes from "../../assets/apiRoutes.json";
let ItemId = "";
let LotId = "";
const ItemModeGrid = (props) => {
    const dataGrid = useRef(null);
    var detailDataGrid = React.createRef();
    var accessToken = props.oidc.user.access_token;
    var customerRowId = "notset";
    var rCustomer = props.ReceiptReducer.receipt[0]?.rCustomer;

    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const handleValueChange = (e) => {
    };

    // Cell editing sends only the changed cell, so the optimistic-concurrency token has to be carried
    // over from the loaded row or the server receives none and the version check silently no-ops.
    // Only the token is copied, not all of oldData: UpdateDetail writes whichever of Quantityorder /
    // Lotid / itemid are present, so widening the payload would change what this screen persists.
    const onRowUpdating = (e) => {
        if (!e.newData.hasOwnProperty('concurrencyToken')) {
            e.newData['concurrencyToken'] = e.oldData['concurrencyToken'];
        }
    };
    if (customerRowId == "notset") {
        customerRowId = "";
        if (rCustomer != null && rCustomer != undefined) {
            customerRowId = rCustomer;
        }
    }
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const [currentLayout, setCurrentLayout] = useState("Default");
    const gridKey = "b5f31590-6e75-4dd0-930c-408b07b514e4";
    const dataSource = createConcurrencyAwareStore({
        onConflict: refreshGridOnConflict(dataGrid),
        key: 'rowid',
        loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Receipt.GetReceiptDetailItems}`,
        insertUrl: `${window._env_.REACT_APP_APIS}/${routes.Receipt.InsertReceiptDetailItems}`,
        updateUrl: `${window._env_.REACT_APP_APIS}/${routes.Receipt.UpdateTransactionDetails}`,
        onBeforeSend: function (method, ajaxOptions) {
            ajaxOptions.headers = {
                Authorization: `Bearer ${accessToken}`,
                'identityMasterRowId': props.headerId,
            };
            if (method === 'update') {
                ajaxOptions.data = ajaxOptions.data || {};
                ajaxOptions.headers.key = ajaxOptions.data.key ?? "";
            }
            if (method === 'load' || method === 'insert') {
                ajaxOptions.data = ajaxOptions.data || {};
                ajaxOptions.headers.key = props.headerId ?? "";
            }
        }
    });
    const onContentReady = async (e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            e.component.option("dataSource", dataSource);
        }
    }
    async function setItemValue(rowData, value) {

        try {
            await fetchItemByRowid(ItemId, rowData);
            rowData.itemid = ItemId;
            rowData.itemcode = value;
        } catch (error) {
            console.error("Failed to fetch item data:", error);
        }
    }
    const renderItemCell = (cellElement) => {
        const items = LoadItems()
        const currentValue = cellElement.data.itemid;
        return (
            <SelectBox
                dataSource={items}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                acceptCustomValue={true}
                searchEnabled={true}
                searchExpr="Name"
                searchMode="contains"
                onValueChanged={async (e) => {
                    const selectedText = e.component.option('displayValue');
                    ItemId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    function setLotValue(rowData, value) {
        rowData.lotId = LotId;
        rowData.lotcode = value;
    }
    const renderLotCell = (cellElement) => {
        const lots = LoadLots(cellElement.row.data?.itemid)
        const currentValue = cellElement.row.data.lotid;
        return (
            <SelectBox
                dataSource={lots}
                valueExpr="id"
                displayExpr="name"
                defaultValue={currentValue}
                searchEnabled={true}
                searchMode="contains"
                searchExpr="Name"
                onValueChanged={(e) => {
                    const selectedText = e.component.option('displayValue');
                    LotId = e.value;
                    cellElement.setValue(selectedText);
                }}
            />
        );
    }
    const fetchItemByRowid = async (itemId, rowData) => {

        await axios.get(`${window._env_.REACT_APP_APIS}/${routes.Receipt.GetItemByRowid}`, {
            params: {
                itemid: itemId,
                headerId: props.headerId,
            },
            headers: {
                "Content-Type": "application/json",
                access_token: accessToken,
            },
        })
            .then((response) => {
                rowData.lotId = response.data.lotId;
                LotId = response.data.lotId;
                rowData.lotcode = response.data.lotName;
                rowData.description1 = response.data.itemDescription1;
                rowData.classcode = response.data.classcode;
                rowData.itemid = response.data.itemid;
                rowData.palletsizecode = response.data.palletsizecode;
                rowData.subclasscode = response.data.subclasscode;
                rowData.dateavailable = response.data.dateavailable;
                rowData.status = response.data.status;
                rowData.dateexpiration = response.data.dateexpiration;
                rowData.netavailable = response.data.netavailable;
                rowData.receiptpacksize = response.data.receiptpacksize;
                rowData.receiptuomdefault = response.data.receiptuomdefault;
                console.log('Response:', response.data);
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    };
    const LoadLots = (itemId) => {
        const lots = new DataSource({
            store:createStore({
              loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Lot.GetLots}`,
              key: 'id',
              loadParams: {
                masterRowId: function () {
                    return itemId;
                }
              },
              onBeforeSend: function (method, ajaxOptions) {
                  ajaxOptions.headers = {
                      access_token: accessToken
                  };
              }
          }),
          sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        }); 
        return lots;
    };
    const LoadItems = () => {
        const items = new DataSource({
            store: createStore({
                loadUrl: `${window._env_.REACT_APP_APIS}/${routes.Item.GetItems}`,
                key: 'id',
                loadParams: {
                    customerIdentity: props.selectedCustomerId
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`
                    };
                }
            }),
            sort: [{ selector: "name", desc: false }],
            paginate: true,
            pageSize: 100
        });
        return items;
    };
    return (
        <div >
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                id="gridContainer"
                visible={props.displayItemModeGrid}
                onContentReady={onContentReady}
                ref={dataGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                //onSelectionChanged={handleCellValueChanged}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                className={props.searchPanelStatus ? "StyleGridHightWithAccordianOpen" : "StyleGridHightWithAccordianClose"}
                columnAutoWidth={true}
                onRowUpdating={onRowUpdating}
                onRowUpdated={handleValueChange}
                onRowInserted={handleValueChange}
            >
                <Scrolling mode="standard" />

                <Export enabled={true} allowExportSelectedData={true} />
                <Sorting visible={true} mode="multiple" />
                <Paging enabled={true} defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                    showInfo={true}
                />
                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowAdding={true}
                />
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <Column
                    dataField="rowid"
                    caption="rowId#"
                    visible={false}
                />
                <Column
                    dataField="quantityorder"
                    dataType="number"
                    caption="Ordered"
                ></Column>

                <Column dataField="itemcode" editCellRender={renderItemCell} setCellValue={setItemValue} caption='Item' >
                    <RequiredRule message="The Warehouse field is required." />

                </Column>
                <Column
                    dataField="description1"
                    caption="Item Description - 1"
                    allowEditing={false}
                > </Column>

                <Column
                    dataField="classcode"
                    caption="Class"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataField="palletsizecode"
                    caption="PalletSizeCode"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataField="subclasscode"
                    caption="SubClass"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataField="status"
                    caption="Status"
                    allowEditing={false}

                > </Column>
                <Column
                    dataType="date"
                    dataField="dateavailable"
                    caption="Item Date Available"
                    allowEditing={false}
                ></Column>
                <Column
                    dataType="date"
                    dataField="dateexpiration"
                    caption="Item Date Expiration"
                    allowEditing={false}
                ></Column>
                <Column
                    dataField="netavailable"
                    caption="Item Net Avl"
                    allowEditing={false}
                ></Column>
                <Column
                    dataField="receiptuomdefault"
                    caption="UOM Default"
                    allowEditing={false}
                ></Column>
                <Column
                    dataField="receiptpacksize"
                    caption="Pack Size"
                    allowEditing={false}
                ></Column>
                <Column dataField="lotcode" caption='Lot' editCellRender={renderLotCell} setCellValue={setLotValue} />
                <Column
                    dataField="lotDescription1"
                    caption="Lot Description - 1"
                    allowEditing={false}
                ></Column>
                <Column
                    dataField="lotDescription2"
                    caption="Lot Description - 2"
                    allowEditing={false}
                    visible={false}>
                </Column>
                <Column
                    dataField="lotUserdefinedreference8"
                    caption="Lot Reference 8"
                    allowEditing={false}
                    visible={false}>
                </Column>
                <Column
                    dataField="lotNetavailable"
                    caption="Lot Net Avl"
                    allowEditing={false}
                ></Column>
                <Column
                    dataType="date"
                    dataField="lotDateExpiration"
                    caption="Lot Date Expiration"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataType="date"
                    dataField="LotDateAvailable"
                    caption="Lot Date Available"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataType="date"
                    dataField="Dateintroduced"
                    caption="Lot Date Introduced"
                    allowEditing={false}
                    visible={false}
                ></Column>
                <Column
                    dataField="Unitsperpackagequantity"
                    caption="Lot Units / Package"
                    allowEditing={false}
                    visible={false}>
                </Column>
                <Column
                    dataField="Intransactionnumber"
                    caption="Lot First Receipt"
                    allowEditing={false}
                    visible={false}>
                </Column>
                <Toolbar>
                    <Item>
                        <SelectBox
                            width="201"
                            stylingMode='outlined'
                            items={props.detailDataGridModes}
                            displayExpr="text"
                            valueExpr="value"
                            value={props.selectedValue}
                            onValueChanged={props.detailDataGridModeChanged} />
                    </Item>

                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={detailDataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item
                        name="addRowButton"
                    />
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc,
        ReceiptReducer: state.ReceiptReducer,
    };
}
export default connect(mapStateToProps)(ItemModeGrid);